var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWrench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.29 13.7705L13.7 15.1805L4.71 24.1905L4 24.4805H2L1.29 24.1905L0.29 23.1905L0 22.4805V20.4805L0.29 19.7705L9.29 10.7705L10.7 12.1805L2 20.8905V22.0605L2.41 22.4705H3.58L12.29 13.7705ZM23.89 7.03053L22.89 5.03053L21.29 4.77053L18.58 7.48053H17.41L17 7.07053V5.90053L19.71 3.19053L19.45 1.59053L17.45 0.590527L16.69 0.540527L13.69 1.54053L13.3 1.78053L11.3 3.78053L11.01 4.49053V9.08053L10.3 9.79053L11.71 11.2005L12.71 10.2005L13 9.49053V4.89053L14.54 3.35053L16.92 2.56053L17.31 2.75053L15.29 4.77053L15 5.48053V7.48053L15.29 8.19053L16.29 9.19053L17 9.48053H19L19.71 9.19053L21.73 7.17053L21.92 7.56053L21.13 9.94053L19.59 11.4805H15L14.29 11.7705L13.29 12.7705L14.7 14.1805L15.41 13.4705H20L20.71 13.1805L22.71 11.1805L22.95 10.7905L23.95 7.79053L23.9 7.03053H23.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWrench);
export default __webpack_public_path__ + "static/1787821308/media/icon-wrench.452295561d41e6df2065720daad4bbf0.svg";
export { ForwardRef as ReactComponent };